import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const COOKIE_KEY = "codigo29_cookies_accepted";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Solo mostrar si no ha aceptado ni rechazado aún
    const stored = localStorage.getItem(COOKIE_KEY);
    if (!stored) {
      // Pequeño delay para no interrumpir la carga inicial
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(COOKIE_KEY, "rejected");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", damping: 20, stiffness: 200 }}
          className="fixed bottom-0 left-0 right-0 z-[9999] px-4 pb-4 sm:px-6 sm:pb-6"
        >
          <div className="max-w-4xl mx-auto glass border border-white/10 rounded-xl p-4 sm:p-5 shadow-[0_-4px_40px_rgba(0,0,0,0.5)]">
            {/* Barra decorativa superior */}
            <div className="absolute top-0 left-0 w-full h-[2px] rounded-t-xl bg-gradient-to-r from-neonBlue via-neonPurple to-neonRed" />

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              {/* Ícono */}
              <span className="text-3xl flex-shrink-0" aria-hidden>🍪</span>

              {/* Texto */}
              <div className="flex-1">
                <p className="text-white font-semibold text-sm">
                  Usamos cookies para mejorar tu experiencia
                </p>
                <p className="text-textSoft text-xs mt-1 leading-relaxed">
                  Utilizamos cookies esenciales para el funcionamiento del sitio y cookies de análisis (Firebase Analytics) para entender cómo navegas. No vendemos tus datos.{" "}
                  <Link to="/privacy" className="text-neonBlue underline hover:text-neonBlue/80 transition-colors" onClick={accept}>
                    Política de Privacidad
                  </Link>
                </p>
              </div>

              {/* Botones */}
              <div className="flex gap-2 flex-shrink-0 w-full sm:w-auto">
                <button
                  onClick={reject}
                  className="flex-1 sm:flex-none px-4 py-2 rounded-lg border border-white/20 text-textSoft text-xs font-semibold hover:border-white/40 hover:text-white transition-all"
                >
                  Solo esenciales
                </button>
                <motion.button
                  onClick={accept}
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.97 }}
                  className="flex-1 sm:flex-none px-4 py-2 rounded-lg bg-neonPurple/20 border border-neonPurple text-neonPurple text-xs font-bold hover:shadow-neon-purple transition-all"
                >
                  Aceptar todo
                </motion.button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
